import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { supabase } from "../lib/supabase";

export function FavoriteButton({ doramaId }: { doramaId: string }) {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [favorite, setFavorite] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!user) {
      setFavorite(false);
      return;
    }
    let active = true;
    supabase
      .from("favorites")
      .select("dorama_id")
      .eq("user_id", user.id)
      .eq("dorama_id", doramaId)
      .maybeSingle()
      .then(({ data }) => active && setFavorite(Boolean(data)));
    return () => { active = false; };
  }, [doramaId, user]);

  async function toggleFavorite() {
    if (!user) {
      navigate(`${location.pathname}?entrar=1`);
      return;
    }
    setBusy(true);
    setMessage(null);
    const result = favorite
      ? await supabase.from("favorites").delete().eq("user_id", user.id).eq("dorama_id", doramaId)
      : await supabase.from("favorites").insert({ user_id: user.id, dorama_id: doramaId });
    if (result.error) setMessage("Execute o SQL de favoritos no Supabase para ativar esta função.");
    else setFavorite(!favorite);
    setBusy(false);
  }

  return (
    <div className="favorite-control">
      <button className={favorite ? "active" : ""} type="button" onClick={toggleFavorite} disabled={busy || authLoading} aria-pressed={favorite}>
        <span aria-hidden="true">{favorite ? "♥" : "♡"}</span> {favorite ? "Favoritado" : "Favoritar"}
      </button>
      {message && <small role="status">{message}</small>}
    </div>
  );
}
